<template>
  <div class="article mx-2 my-2">
    <h3 class="article-title pb-2">{{article.title}}</h3>
    <div v-if="article.pdf">
      附件:
      <a :href="article.pdfUrl" target="_blank">{{article.pdfName}}</a>
    </div>
    <v-divider class="mb-2" />
    <div v-html="article.content"></div>
    <div v-if="movieUrl" style="width: 600px">
      <CcVideoViewer :cfg="{'movieUrl': movieUrl}"></CcVideoViewer>
    </div>
  </div>
</template>

<script>
import CcVideoViewer from "@/components/cc-video-viewer.vue";

export default {
  name: "article-view",
  props: {
    cfg: Object
  },
  components: {
    CcVideoViewer
  },
  watch: {
    cfg() {
      this.init();
    }
  },
  data() {
    return {
      article: {},
      movieUrl: null
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      let self = this;
      if (!self.cfg) {
        return;
      }
      let baseUrl = self.cfg.clazz
        ? "/home/admin/my/tenant/clazz/article"
        : "/home/my/article";

      self.$axios
        .get(`${baseUrl}/get/${self.cfg.id}`, { params: self.cfg.params })
        .then(r => {
          if (r.data && r.data.status == "ok") {
            let a = r.data.message;
            if (a.pdf) {
              let tmp = a.pdf.split("/");
              a.pdfUrl = `${self.$const.baseUrl}${baseUrl}/pdf/${self.cfg.id}/${tmp[0]}`;
              if (self.cfg.params && self.cfg.params._clazzId) {
                a.pdfUrl = a.pdfUrl + '?_clazzId=' + self.cfg.params._clazzId;
              }
              a.pdfName = tmp.length > 1 ? tmp[1] : tmp[0];
            }
            self.article = a;

            if (a.videoId) {
              self.$axios.get(`/home/my/media/cc/url/${a.videoId}`).then(sr => {
                if (sr.data && sr.data.status == "ok") {
                  self.movieUrl = sr.data.message;
                }
              });
            }
          }
        });
    }
  }
};
</script>
<style>
.article img {
  max-width: 100%;
}

.article .article-title {
  font-size: 20px;
}
</style>

